<template>
    <div>
        <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item label="公告标题" prop="noticeTitle">
                <el-input
                v-model="dataForm.noticeTitle"
                placeholder="请输入公告标题"
                clearable
                size="small"
                />
            </el-form-item>
            <el-form-item label="类型" prop="noticeType">
                <el-select v-model="dataForm.noticeType" placeholder="公告类型" clearable size="small">
                    <el-option value="0" label="通知公告"/>
                    <el-option value="1" label="供应商绩效通知"/>
                </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="noticeStatus">
                <el-select v-model="dataForm.noticeStatus" placeholder="公告状态" clearable size="small">
                    <el-option value="0" label="正常"/>
                    <el-option value="1" label="关闭"/>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="getDataList()">搜索</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="addOrUpdateHandle()">新增</el-button>
                <el-button size="small" type="warning" @click="sendHandle()" :disabled="dataListSelections.length <= 0">发送邮件通知</el-button>
                <el-button size="small" type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0">批量删除</el-button>
            </el-form-item>
        </el-form>

        <el-table
                :data="dataList"
                stripe
                v-loading="dataListLoading"
                :height = "documentClientHeight"
                @selection-change="selectionChangeHandle"
                style="width: 100%;">

            <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="50">
            </el-table-column>

            <el-table-column
                    prop="id"
                    header-align="center"
                    align="center"
                    label="序号" width="50px">
            </el-table-column>

            <el-table-column
                    prop="noticeType"
                    header-align="center"
                    align="center"
                    width="120px"
                    label="类型">
                <template slot-scope="scope">
                    <span v-if="scope.row.noticeType == '0'">通知</span>
                    <span v-if="scope.row.noticeType == '1'">供应商绩效通知</span>
                </template>
            </el-table-column>

            <el-table-column
                    prop="noticeTitle"
                    header-align="center"
                    align="center"
                    width="300px"
                    label="标题">
            </el-table-column>

            <el-table-column
                    prop="noticeContent"
                    header-align="center"
                    align="center"
                    width="150px"
                    label="内容">
                <template slot-scope="scope">
                    <el-button size="small" @click="dialogNoticeContent(scope.row)">点击查看内容</el-button>
                </template>
            </el-table-column>

            <el-table-column
                    prop="noticeStatus"
                    header-align="center"
                    align="center"
                    width="80px"
                    label="状态">
                <template slot-scope="scope">
                    <span v-if="scope.row.noticeStatus == '0'">正常</span>
                    <span v-if="scope.row.noticeStatus == '1'">关闭</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="createByName"
                    header-align="center"
                    align="center"
                    width="120px"
                    label="创建人">
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    header-align="center"
                    align="center"
                    width="180px"
                    label="创建时间">
            </el-table-column>

            <el-table-column
                    prop="sendStatus"
                    header-align="center"
                    align="center"
                    width="120px"
                    label="发送状态">
                <template slot-scope="scope">
                    <span style="color:#409EFF" v-if="scope.row.sendStatus == '0'">未发送</span>
<!--                    <span style="color:#F56C6C" v-if="scope.row.sendStatus == '1'">发送失败</span>-->
                    <span style="color:#67C23A" v-if="scope.row.sendStatus == '2'">发送成功</span>
                    <span style="color:#67C23A" v-if="scope.row.sendStatus == '1'">发送成功</span>
                </template>
            </el-table-column>

            <el-table-column
                    prop="sendType"
                    header-align="center"
                    align="center"
                    width="80px"
                    label="发送类型">
                <template slot-scope="scope">
                    <!-- <span v-if="scope.row.sendType == '0'">潜在</span>
                    <span v-if="scope.row.sendType == '1'">合格</span>
                    <span v-if="scope.row.sendType == '2'">一次性</span> -->
                    <span v-if="scope.row.sendType == '8'">全部</span>
                    <span v-if="scope.row.sendType == '9'">部分</span>
                </template>
            </el-table-column>

            <el-table-column
                    fixed="right"
                    header-align="center"
                    align="center"
                    width="150px"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">
                        修改
                    </el-button>
                    <el-button style="color:#F56C6C" type="text" size="small" @click="deleteHandle(scope.row.id)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                :total="totalPage"
                layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>

        <el-dialog title="当前处理含发送邮件，请耐心等待！" :modal='true' :center='true' :visible.sync="sendLoading"
            :modal-append-to-body='true' :append-to-body='true' width='400px'
            :close-on-click-modal='false' :close-on-press-escape='false' :show-close='false'>
        </el-dialog>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <!-- 弹窗的通知公告 -->
        <el-dialog title="通知公告" :visible.sync="showContent" width="">
            <el-form :model="dataForm" label-width="80px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="标题" prop="dialogTitle">
                            <el-input v-model="dialogTitle" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="内容" prop="dialogContent">
                            <el-input type="textarea" v-model="dialogContent" :rows="10" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import { listNotice, delNotice, sendNotice } from '@/controller/supplier';
    import AddOrUpdate from './notice-add-or-update';
    export default {
        data () {
            return {
                documentClientHeight: document.documentElement['clientHeight'] - 220,
                dataForm: {
                    noticeTitle: '',
                    noticeType: '',
                    noticeStatus: '',
                    noticeContent: '',
                    creatBy: ''
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                sendLoading: false,
                addOrUpdateVisible: false,
                showContent: false,
                dialogTitle: '',
                dialogContent: '',
            }
        },
        components: {
            AddOrUpdate
        },
        activated () {
            this.getDataList()
        },
        methods: {
            /** 重置按钮操作 */
            resetQuery() {
                this.dataForm = {
                    noticeTitle: '',
                    noticeType: '',
                    noticeStatus: '',
                    noticeContent: '',
                    creatBy: ''
                };
                this.getDataList();
            },
            // 获取数据列表
            getDataList () {
                this.dataListLoading = true
                listNotice(
                    {
                        'pageNo': this.pageIndex,
                        'pageSize': this.pageSize,
                        'noticeTitle': this.dataForm.noticeTitle,
                        'noticeType': this.dataForm.noticeType,
                        'noticeStatus': this.dataForm.noticeStatus,
                        'creatBy': this.dataForm.creatBy
                    }
                ).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            dialogNoticeContent(row) {
                this.showContent = true;
                this.dialogTitle = row.noticeTitle;
                this.dialogContent = row.noticeContent;
            },
            // 每页数
            sizeChangeHandle (val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle (val) {
                this.pageIndex = val
                this.getDataList()
            },
            // 多选
            selectionChangeHandle (val) {
                this.dataListSelections = val
            },
            // 新增 / 修改
            addOrUpdateHandle (id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id)
                })
            },
            // 删除
            deleteHandle (id) {
                let ids = id ? [id] : this.dataListSelections.map(item => {
                    return item.id
                })
                this.$confirm(`确定进行${id ? '删除' : '批量删除'}操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delNotice(
                        ids
                    ).then(data => {
                        if (data && data.code === '00') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {})
            },
            // 群发通知
            sendHandle (id) {
                let ids = id ? [id] : this.dataListSelections.map(item => {
                    return item.id
                });
                if (ids.length != 1) {
                    this.$message.error('请选择一个通知');
                }
                this.$confirm(`确定进行[发送邮件通知]操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.sendLoading = true;
                    sendNotice(
                        ids
                    ).then(data => {
                        if (data && data.code === '00') {
                            this.sendLoading = false;
                            this.$message({
                                message: '操作完成',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.sendLoading = false;
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                    this.sendLoading = false;
                    this.$message.error("操作异常")
                })
            }
        }
    }
</script>
